module.exports = __webpack_public_path__ + "media/images/emblems/Realp-coat_of_arms-273b30a112670048336501c56631aa10.svg";